import { Box } from '@mui/material';
import { styled } from '@mui/system';
import { colors } from '../../constants';
export const BasicButtonStyle = styled(Box)(() => ({
  '& button': {
    border: `1px solid ${colors.blueBase} !important`,
    fontSize: '0.8rem  !important',
    padding: '6px 12px'
  },
  '& .MuiButton-outlined': {
    backgroundColor: `${colors.blueChipBg} !important`,
    color: `${colors.black} !important`,
    textTransform: 'none',
    width: 'auto',
    '&.radiusButton': {
      borderRadius: '3rem !important'
    }
  },
  '& .MuiButton-contained': {
    borderRadius: '8px',
    backgroundColor: `${colors.blueBase} !important`
  },
  '& .MuiButton-text': {
    borderRadius: '1rem',
    backgroundColor: colors.blueChipBg,
    color: colors.black,
    border: `0.125rem solid ${colors.blueBase}!important`,
    '&:hover': {
      backgroundColor: colors.blueButtonLight
    }
  },

  '& .Mui-disabled': {
    backgroundColor: `${colors.buttonDisabledText} !important`,
    border: `1px solid ${colors.buttonDisabledText} !important`,
    color: `${colors.white} !important`,
    cursor: ' not-allowed'
  }
}));
